{
    "en": {
        "translation": {
            "A free form text added to the registration confirmation email that is sent to regatta entry": "A free form text added to the registration confirmation email that is sent to regatta entry",
            "A list of boats that that are available for rent in this regatta": "A list of boats that that are available for rent in this regatta",
            "A list of regatta officials and management persons": "A list of regatta officials and management persons",
            "A list of users that can control this regatta": "A list of users that can control this regatta",
            "A list of values / files asked to input by the regatta entries on the regatta registration form": "A list of values / files asked to input by the regatta entries on the regatta registration form",
            "A short text added to the entry form document bottom": "A short text added to the entry form document bottom",
            "Access tokens": "Access tokens",
            "Active regatta": "Active regatta",
            "Add admin": "Add admin",
            "Add championship admin": "Add championship admin",
            "Add day protest time limit": "Add day protest time limit",
            "Add entries": "Add entries",
            "Add entry": "Add entry",
            "Add first regatta entry": "Add first regatta entry",
            "Add new": "Add new",
            "Add new admin": "Add new admin",
            "Add new advertisement": "Add new advertisement",
            "Add new banner": "Add new banner",
            "Add new championship": "Add new championship",
            "Add new championship result table": "Add new championship result table",
            "Add new crewmember": "Add new crewmember",
            "Add new custom page": "Add new custom page",
            "Add new day event": "Add new day event",
            "Add new discount code": "Add new discount code",
            "Add new document": "Add new document",
            "Add new entry": "Add new entry",
            "Add new group": "Add new group",
            "Add new overall result table": "Add new overall result table",
            "Add new rating": "Add new rating",
            "Add new regatta": "Add new regatta",
            "Add new regatta boat rent": "Add new regatta boat rent",
            "Add new regatta contact": "Add new regatta contact",
            "Add new regatta course": "Add new regatta course",
            "Add new regatta course point": "Add new regatta course point",
            "Add new regatta entry": "Add new regatta entry",
            "Add new regatta entry rating": "Add new regatta entry rating",
            "Add new regatta message": "Add new regatta message",
            "Add new regatta protest": "Add new regatta protest",
            "Add new regatta result diploma template": "Add new regatta result diploma template",
            "Add new regatta result table": "Add new regatta result table",
            "Add new regatta sponsor": "Add new regatta sponsor",
            "Add new region": "Add new region",
            "Add new region season": "Add new region season",
            "Add race": "Add race",
            "Add regatta": "Add regatta",
            "Add regatta entry check": "Add regatta entry check",
            "Add regatta group": "Add regatta group",
            "Add regatta requirement": "Add regatta requirement",
            "Add result table entries": "Add result table entries",
            "Address": "Address",
            "Adds time penalty in percentage (- subtracts)": "Adds time penalty in percentage (- subtracts)",
            "Adds time penalty in seconds (- subtracts)": "Adds time penalty in seconds (- subtracts)",
            "Aditional organizer contact info": "Aditional organizer contact info",
            "Admin": "Admin",
            "Admin access token": "Admin access token",
            "Admin access tokens": "Admin access tokens",
            "Admin social user": "Admin social user",
            "Admin social users": "Admin social users",
            "Admins": "Admins",
            "Advertisement": "Advertisement",
            "Age": "Age",
            "Age on birthday": "Age on birthday",
            "Allow entries to change group": "Allow entries to change group",
            "Allow entries to input additional sail no.": "Allow entries to input additional sail no.",
            "Allow entries to submit protests": "Allow entries to submit protests",
            "Alternative title": "Alternative title",
            "Apply": "Apply",
            "Approve all": "Approve all",
            "Approved": "Approved",
            "Approved race": "Approved race",
            "Awaiting payment": "Awaiting payment",
            "Back to login form": "Back to login form",
            "Banners": "Banners",
            "Birthday": "Birthday",
            "Birthday during regatta": "Birthday during regatta",
            "Button classes": "Button classes",
            "Button link": "Button link",
            "Button name": "Button name",
            "By this you confirm that you need an invoice": "By this you confirm that you need an invoice",
            "Calculation type": "Calculation type",
            "Cancel": "Cancel",
            "Cancel regatta": "Cancel regatta",
            "Cents": "Cents",
            "Championship admin": "Championship admin",
            "Championship admin request": "Championship admin request",
            "Championship admins": "Championship admins",
            "Championship description": "Championship description",
            "Championship documents": "Championship documents",
            "Championship pending admins": "Championship pending admins",
            "Championship regatta": "Championship regatta",
            "Championship result table": "Championship result table",
            "Championship result table entry": "Championship result table entry",
            "Championship result table race": "Championship result table race",
            "Championship results": "Championship results",
            "Championship settings": "Championship settings",
            "Circumstances defined (DNC, DNS, OCS, ZFP, UFD, BFD, SCP, DNF, RET, DSQ, DNE, DGM, RDG, DPI)": "Circumstances defined (DNC, DNS, OCS, ZFP, UFD, BFD, SCP, DNF, RET, DSQ, DNE, DGM, RDG, DPI)",
            "Circumstances defined with points assigned": "Circumstances defined with points assigned",
            "Class flag": "Class flag",
            "Clear": "Clear",
            "Clone": "Clone",
            "Coef": "Coef",
            "Collect coach data": "Collect coach data",
            "Color": "Color",
            "Company name": "Company name",
            "Confirm cancellation": "Confirm cancellation",
            "Confirmation code": "Confirmation code",
            "Confirmation code is sent to your email": "Confirmation code is sent to your email",
            "Contact us": "Contact us",
            "Container classes": "Container classes",
            "Content": "Content",
            "Crew quantity": "Crew quantity",
            "Crewmember access token": "Crewmember access token",
            "Crewmember social user": "Crewmember social user",
            "Crewmember social users": "Crewmember social users",
            "Crewmembers": "Crewmembers",
            "Custom page": "Custom page",
            "Custom pages": "Custom pages",
            "Custom registration form consent text": "Custom registration form consent text",
            "Data": "Data",
            "Date created": "Date created",
            "Date format": "Date format",
            "Date formats": "Date formats",
            "Delete": "Delete",
            "Delete race": "Delete race",
            "Delete request": "Delete request",
            "Delete result table": "Delete result table",
            "Delete table": "Delete table",
            "Deleted successfully!": "Deleted successfully!",
            "Deleted unsuccessfully!": "Deleted unsuccessfully!",
            "Description": "Description",
            "Details": "Details",
            "Diff": "Diff",
            "Discards": "Discards",
            "Discount": "Discount",
            "Discount code": "Discount code",
            "Discount code invalid": "Discount code invalid",
            "Do you really want to add regatta entry?": "Do you really want to add regatta entry?",
            "Do you really want to add this user to admins?": "Do you really want to add this user to admins?",
            "Do you really want to cancel regatta?": "Do you really want to cancel regatta?",
            "Do you really want to delete?": "Do you really want to delete?",
            "Do you really want to reject?": "Do you really want to reject?",
            "Do you really want to remove?": "Do you really want to remove?",
            "Do you really want to revoke?": "Do you really want to revoke?",
            "Document as PDF file": "Document as PDF file",
            "Document as free text": "Document as free text",
            "Document date": "Document date",
            "Domain": "Domain",
            "Dominant": "Dominant",
            "Dropdown values": "Dropdown values",
            "Edit": "Edit",
            "Edit championship result table entry": "Edit championship result table entry",
            "Edit on map": "Edit on map",
            "Edit race": "Edit race",
            "Edit result table": "Edit result table",
            "Edit table": "Edit table",
            "Email already occupied": "Email already occupied",
            "Email not found": "Email not found",
            "Empty entry form": "Empty entry form",
            "Enabled": "Enabled",
            "Enter confirmation code": "Enter confirmation code",
            "Enter email": "Enter email",
            "Enter new password": "Enter new password",
            "Enter password": "Enter password",
            "Entry rating": "Entry rating",
            "Entry ratings": "Entry ratings",
            "Event end date": "Event end date",
            "Event place": "Event place",
            "Event start date": "Event start date",
            "Event title": "Event title",
            "Example file": "Example file",
            "Expired": "Expired",
            "Filter": "Filter",
            "Finish time input (M - Month, D - Day, H - Hour, M - Minute, S - Second)": "Finish time input (M - Month, D - Day, H - Hour, M - Minute, S - Second)",
            "Flag": "Flag",
            "Forgot password?": "Forgot password?",
            "Found items": "Found items",
            "Free form regatta description": "Free form regatta description",
            "Group entries list": "Group entries list",
            "Group results": "Group results",
            "Hidden": "Hidden",
            "Hide finished": "Hide finished",
            "Highlight": "Highlight",
            "Hour": "Hour",
            "I want to control championship": "I want to control championship",
            "I want to control regatta": "I want to control regatta",
            "I want to create championship": "I want to create championship",
            "I want to create regatta": "I want to create regatta",
            "If POS field is left undefined position is calculated defned by finish time": "If POS field is left undefined position is calculated defned by finish time",
            "Incorrect code": "Incorrect code",
            "Incorrect password": "Incorrect password",
            "Input new password": "Input new password",
            "Input your account email": "Input your account email",
            "Instructions": "Instructions",
            "Interval": "Interval",
            "Invert points": "Invert points",
            "Invoice": "Invoice",
            "Invoice details": "Invoice details",
            "Invoices": "Invoices",
            "Label": "Label",
            "Language": "Language",
            "Last year regatta": "Last year regatta",
            "Latest": "Latest",
            "Length": "Length",
            "Link": "Link",
            "List": "List",
            "Location": "Location",
            "Lock": "Lock",
            "Locked": "Locked",
            "Login": "Login",
            "Max crewmembers in entry quantity": "Max crewmembers in entry quantity",
            "Max entries in group quantity": "Max entries in group quantity",
            "Mean age": "Mean age",
            "Mean oldest entry": "Mean oldest entry",
            "Mean youngest entry": "Mean youngest entry",
            "Membership": "Membership",
            "Minute": "Minute",
            "Model": "Model",
            "Month": "Month",
            "Name override": "Name override",
            "Need confirmation": "Need confirmation",
            "New championship result table": "New championship result table",
            "New championship result table entry": "New championship result table entry",
            "New championship result table race": "New championship result table race",
            "New password": "New password",
            "New position": "New position",
            "No data": "No data",
            "No rating": "No rating",
            "Old password": "Old password",
            "Oldest crewmember": "Oldest crewmember",
            "On": "On",
            "Open calendar": "Open calendar",
            "Organizer email": "Organizer email",
            "Organizer name": "Organizer name",
            "POS field value options": "POS field value options",
            "Page": "Page",
            "Page address": "Page address",
            "Paid": "Paid",
            "Password": "Password",
            "Pay": "Pay",
            "Pay with the card": "Pay with the card",
            "Payment": "Payment",
            "Payment ID": "Payment ID",
            "Payment successful": "Payment successful",
            "Payments": "Payments",
            "Pending championship admin requests": "Pending championship admin requests",
            "Pending regatta admin requests": "Pending regatta admin requests",
            "Picture": "Picture",
            "Plc": "Plc",
            "Please select region": "Please select region",
            "Position calculation value": "Position calculation value",
            "Prep. flag": "Prep. flag",
            "Prevent duplicate entry registration no.": "Prevent duplicate entry registration no.",
            "Previous position": "Previous position",
            "Profile": "Profile",
            "Profile settings": "Profile settings",
            "Profile social users": "Profile social users",
            "Protest end time": "Protest end time",
            "Protests list": "Protests list",
            "Pts": "Pts",
            "Public": "Public",
            "Publish date": "Publish date",
            "Publish race": "Publish race",
            "Publish regatta": "Publish regatta",
            "Purchase includes enabled regatta registration feature without any limitations": "Purchase includes enabled regatta registration feature without any limitations",
            "Rating type": "Rating type",
            "Read": "Read",
            "Reference": "Reference",
            "Reference championship": "Reference championship",
            "Reg no.": "Reg no.",
            "Reg. letters": "Reg. letters",
            "Regatta admin": "Regatta admin",
            "Regatta admin request": "Regatta admin request",
            "Regatta admins": "Regatta admins",
            "Regatta boat rent": "Regatta boat rent",
            "Regatta boat rents": "Regatta boat rents",
            "Regatta check": "Regatta check",
            "Regatta clock": "Regatta clock",
            "Regatta contact": "Regatta contact",
            "Regatta contacts": "Regatta contacts",
            "Regatta course": "Regatta course",
            "Regatta course map": "Regatta course map",
            "Regatta course points": "Regatta course points",
            "Regatta course race": "Regatta course race",
            "Regatta courses": "Regatta courses",
            "Regatta day protest time limit": "Regatta day protest time limit",
            "Regatta description": "Regatta description",
            "Regatta documents": "Regatta documents",
            "Regatta entries": "Regatta entries",
            "Regatta entries will be notified by email about regatta settings change.": "Regatta entries will be notified by email about regatta settings change.",
            "Regatta entry check": "Regatta entry check",
            "Regatta entry checks": "Regatta entry checks",
            "Regatta entry crewmember statistics": "Regatta entry crewmember statistics",
            "Regatta entry rating": "Regatta entry rating",
            "Regatta entry ratings": "Regatta entry ratings",
            "Regatta entry requirements": "Regatta entry requirements",
            "Regatta groups": "Regatta groups",
            "Regatta logs": "Regatta logs",
            "Regatta messages": "Regatta messages",
            "Regatta overall result": "Regatta overall result",
            "Regatta payment": "Regatta payment",
            "Regatta payment discount": "Regatta payment discount",
            "Regatta payment discounts": "Regatta payment discounts",
            "Regatta protest time limit": "Regatta protest time limit",
            "Regatta protests": "Regatta protests",
            "Regatta registration": "Regatta registration",
            "Regatta registration email appendix": "Regatta registration email appendix",
            "Regatta registration form settings": "Regatta registration form settings",
            "Regatta registration group": "Regatta registration group",
            "Regatta registration requirement": "Regatta registration requirement",
            "Regatta requirement": "Regatta requirement",
            "Regatta requirements": "Regatta requirements",
            "Regatta result diploma": "Regatta result diploma",
            "Regatta result diplomas": "Regatta result diplomas",
            "Regatta result table": "Regatta result table",
            "Regatta result table entries": "Regatta result table entries",
            "Regatta result table entry": "Regatta result table entry",
            "Regatta result table race": "Regatta result table race",
            "Regatta result tables": "Regatta result tables",
            "Regatta schedule event": "Regatta schedule event",
            "Regatta settings": "Regatta settings",
            "Regatta settings change": "Regatta settings change",
            "Regatta sponsor": "Regatta sponsor",
            "Regatta sponsors": "Regatta sponsors",
            "Regatta status": "Regatta status",
            "RegattaNotifications": "RegattaNotifications",
            "RegattaPaymentDiscount": "RegattaPaymentDiscount",
            "Regio seasons": "Regio seasons",
            "Region season": "Region season",
            "Region seasons": "Region seasons",
            "Registration end date": "Registration end date",
            "Registration start date": "Registration start date",
            "Reject": "Reject",
            "Remarks": "Remarks",
            "Remarks invisible to entry": "Remarks invisible to entry",
            "Remove": "Remove",
            "Reorder these positions?": "Reorder these positions?",
            "Repeat new password": "Repeat new password",
            "Repeat password": "Repeat password",
            "Reqs.": "Reqs.",
            "Request invoice": "Request invoice",
            "Require to fill registration form crewmember birthdate field": "Require to fill registration form crewmember birthdate field",
            "Require to fill registration form crewmember email field": "Require to fill registration form crewmember email field",
            "Require to fill registration form crewmember membership id field": "Require to fill registration form crewmember membership id field",
            "Require to fill registration form crewmember tshirt field": "Require to fill registration form crewmember tshirt field",
            "Require to fill registration form crewmember weight field": "Require to fill registration form crewmember weight field",
            "Require to fill registration form entry club field": "Require to fill registration form entry club field",
            "Require to fill registration form entry harbor / city field": "Require to fill registration form entry harbor / city field",
            "Required": "Required",
            "Resend confirmation code": "Resend confirmation code",
            "Reset password": "Reset password",
            "Result": "Result",
            "Review": "Review",
            "Revoke": "Revoke",
            "Save": "Save",
            "Save result": "Save result",
            "Saved successfully": "Saved successfully",
            "Saved unsuccessfully!": "Saved unsuccessfully!",
            "Season": "Season",
            "Second": "Second",
            "Select championships you want to control": "Select championships you want to control",
            "Select multiple": "Select multiple",
            "Select regattas you want to control": "Select regattas you want to control",
            "Select the race to input data": "Select the race to input data",
            "Send reset link": "Send reset link",
            "Sent": "Sent",
            "Sequence": "Sequence",
            "Short format": "Short format",
            "Show all fields": "Show all fields",
            "Show less fields": "Show less fields",
            "Show place column": "Show place column",
            "Show points column": "Show points column",
            "Show preliminary crewmember quantity field": "Show preliminary crewmember quantity field",
            "Show time column": "Show time column",
            "Side": "Side",
            "Sign in to continue": "Sign in to continue",
            "Slug": "Slug",
            "Social users": "Social users",
            "Start date": "Start date",
            "Start group": "Start group",
            "Start now": "Start now",
            "Start procedure in": "Start procedure in",
            "Start procedure watch": "Start procedure watch",
            "Start time": "Start time",
            "Status description": "Status description",
            "Stop": "Stop",
            "Stop edit on map": "Stop edit on map",
            "Stricly assigned position, (overwrites position calculated by defined finish time)": "Stricly assigned position, (overwrites position calculated by defined finish time)",
            "Super user control": "Super user control",
            "Superuser": "Superuser",
            "Sync to latest ratings": "Sync to latest ratings",
            "Tables": "Tables",
            "Tiles": "Tiles",
            "Time format": "Time format",
            "Timezone": "Timezone",
            "Trackers": "Trackers",
            "Uid": "Uid",
            "Unable to get data": "Unable to get data",
            "Unapproved race": "Unapproved race",
            "Undefined": "Undefined",
            "Undiscard": "Undiscard",
            "Undo cancel": "Undo cancel",
            "Unmatched entries": "Unmatched entries",
            "Unpublish race": "Unpublish race",
            "Unpublished": "Unpublished",
            "Update ratings": "Update ratings",
            "Url": "Url",
            "Use bow numbers": "Use bow numbers",
            "Use country instead of registration no.": "Use country instead of registration no.",
            "Used": "Used",
            "VAT no.": "VAT no.",
            "Values is required": "Values is required",
            "Various checks that has to be passed by reagtta entries before the race": "Various checks that has to be passed by reagtta entries before the race",
            "View": "View",
            "Visibility": "Visibility",
            "Visible": "Visible",
            "Visible on regattas list page": "Visible on regattas list page",
            "Warning": "Warning",
            "Year": "Year",
            "You do not have any regattas on the list, you can either create a new regatta or request control of a regatta that is already present on the particular region season": "You do not have any regattas on the list, you can either create a new regatta or request control of a regatta that is already present on the particular region season",
            "Youngest crewmember": "Youngest crewmember",
            "Your session will be closed": "Your session will be closed",
            "dashboard.WELCOME": "dashboard.WELCOME",
            "position": "position",
            "roundings": "roundings",
            "time": "time"
        }
    }
}
